import { createSlice } from "@reduxjs/toolkit";
import { ID_TYPE } from "constants/o2Appointment";

/* const initialStateVerification = {
  email: null,
  passport: null,
  otpToken: null,
  name: null,
  timeslotId: null,
  apptDate: null,
  haveCpfAccountNumber: null,
} */

const initialState = {
  // string, apopintmentInfo.bookingtxnId
  bookingTxnId: null,
  // string, layout modal
  error: null,
  // boolean, form.ack
  ack: null,
  // number, appointmentEntry.mid
  mid: null, 
  // string, appointmentEntry.midDesc
  midDesc: null, 
  // number, appointmentEntry.sid
  sid: null, 
  // string, appointmentEntry.sidDesc
  sidDesc: null, 
  // boolean, appointmentEntry.isCrps
  isCrps: null,
  // string, appointmentEntry.crpsError
  crpsError: null,
  // boolean, appointmentEntry.isExperience
  isExperience: null,
  // string, identity.idType, NRIC_FIN | PASSPORT
  idType: ID_TYPE.NRIC_FIN, 
  // string, identity.nricFin, login.nricFin
  nricFin: null, 
  // string, identity.passport, login.passport
  passport: null, 
  // number, appointmentEntry.apptTypeId
  apptTypeId: null, 
  // string, appointmentEntry.apptTypeCode
  apptTypeCode: null, 
  // string, appointmentEntry.apptType, VISIT | PHONE
  apptType: null, 
  // boolean, appointmentEntry.apptType.isSlotAvailable
  isSlotAvailable: null,
  // boolean, appointmentEntry.haveCompanion
  haveCompanion: false, 
  // string, appointmentEntry.companionIdType, NRIC_FIN | PASSPORT
  companionIdType: ID_TYPE.NRIC_FIN, 
  // string, appointmentEntry.companionNricFin
  companionNricFin: null,
  // string, appointmentEntry.companionPassport
  companionPassport: null,
  // number, appointmentEntry.companionApptTimeslotId
  companionApptTimeslotId: null,
  // string, appointmentEntry.language, EN | CH | MA | TA
  language: "EN",
  // number, appointmentEntry.locationId
  locationId: null,
  // string, appointmentEntry.locationDesc
  locationDesc: null, 
  // number, appointmentEntry.apptDateId
  apptDateId: null,
  // date, appointmentEntry.apptDate
  // only date part associated with apptDateId
  apptDate: null,
  // number, appointmentEntry.apptTimeRangeId
  apptTimeRangeId: null, 
  // number, appointmentEntry.apptTimeslotId
  apptTimeslotId: null,
  // date, appointmentEntry.timeslot.apptDateTime
  // date and time, associated with apptDateId + apptTimeslotId
  apptDateTime: null, 
  // [{id:number, text:string, timeslotInterval: number}], timeslots
  apptTimeslots: [],
  // string, contactDetail.modeOfContact, PHONE | EMAIL
  modeOfContact: null,
  // boolean, contactDetail.mobileUseUCD
  mobileUseUCD: null,
  // string, contactDetail.mobileNumberFromUCD
  mobileNumberFromUCD: null,
  // string, contactDetail.mobileNumber
  mobileNumber: null,
  // boolean, contactDetail.emailUseUCD
  emailUseUCD: null,
  // string, contactDetail.emailFromUCD
  emailFromUCD: null,
  // string, contactDetail.email
  email: null,
  // string, contactDetail.otp
  otp: null,
  // string, contactDetail.otpToken
  otpToken: null,
  otpTokenExpAt: null,

  // string, apointmentWelcome.hasApptNricFin
  hasApptNricFin: null,
  // string, apointmentWelcome.hasApptPassport
  hasApptPassport: null,
  // string, apointmentWelcome.hasApptMaskEmail
  hasApptMaskEmail: null,
  // string, apointmentWelcome.hasApptMaskMobile
  hasApptMaskMobile: null,
  // date, appointmentInfo.transDateTime
  transDateTime: null,
};

export const appointmentSlice = createSlice({
  name: "o2Appointment",
  initialState,
  reducers: {
    clear: (state) => {
      // clear all except mid sid
      // Mid sid will clear only creation or editing appointment is no longer required
      // Which is, appointment review info page.
      return { ...initialState, mid: state.mid, sid: state.sid };
    },
    updateError: (state, { payload }) => {
      return { ...state, error: payload };
    },
    clearApptDateTime: (state) => {
      const apptDateTimeDefault = {
        apptDate: null,
        apptDateId: null,
        apptDateTime: null,
        apptTimeRangeStartTime: null,
        apptTimeRangeEndTime: null,
        apptTimeRangeId: null,
        apptTimeslotId: null,
        apptTimeslots: [],
      };
      return { ...state, ...apptDateTimeDefault };
    },
    clearCompanion:(state)=>{
      const companionDefault = {
        haveCompanion: false,
        companionIdType: ID_TYPE.NRIC_FIN,
        companionNricFin: null,
        companionPassport: null,
        companionApptTimeslotId: null,
      };
      return { ...state, ...companionDefault };
    },
    clearLocation:(state)=>{
      const companionDefault = {
        locationId: null,
        locationDesc: null,
      };
      return { ...state, ...companionDefault };
    },
    clearContactDetail:(state) => {
      const contactDetailDefault =  {
        modeOfContact: null,
        mobileNumber:null,
        email: null,
        otp: null,
        otpToken: null,
      };
      return { ...state, ...contactDetailDefault };
    },
    updateLocationId: (state, { payload }) => {
      return { ...state, locationId: payload };
    },
    updateLocationDesc: (state, { payload }) => {
      return { ...state, locationDesc: payload };
    },
    updateAck: (state, { payload }) => {
      return { ...state, ack: payload };
    },
    updateMid: (state, { payload }) => {
      return { ...state, mid: payload };
    },
    updateMidDesc: (state, { payload }) => {
      return { ...state, midDesc: payload };
    },
    updateSid: (state, { payload }) => {
      return { ...state, sid: payload };
    },
    updateSidDesc: (state, { payload }) => {
      return { ...state, sidDesc: payload };
    },
    clearIdentity: (state) => {
      return { ...state, idType: ID_TYPE.NRIC_FIN, nricFin: null, passport: null };
    },
    updateIdType: (state, {payload}) => {
      return { ...state, idType: payload };
    },
    updateNricFin: (state, {payload}) => {
      return { ...state, nricFin: payload };
    },
    updatePassport: (state, {payload}) => {
      return { ...state, passport: payload };
    },
    nextIdentity: (state, { payload }) => {
      const { idType, nricFin, passport } = payload;
      return { ...state, idType, nricFin, passport };
    },
    updateApptType: (state, { payload }) => {
      const { apptTypeId, apptTypeCode, apptType, isSlotAvailable, locationId } = payload;
      return { ...state, apptTypeId , apptTypeCode, apptType, isSlotAvailable, locationId };
    },
    updateLanguage: (state, { payload }) => {
      return { ...state, language: payload };
    },
    updateHaveCompanion: (state, { payload }) => {
      return { ...state, haveCompanion: payload };
    },
    updateCompanionIdType: (state, { payload }) => {
      return { ...state, companionIdType: payload };
    },
    updateCompanionNricFin: (state, { payload }) => {
      return { ...state, companionNricFin: payload };
    },
    updateCompanionPassport: (state, { payload }) => {
      return { ...state, companionPassport: payload };
    },
    updateCompanionApptTimeslotId:(state, { payload }) => {
      return { ...state, companionApptTimeslotId: payload };
    },
    updateApptDateId: (state, { payload }) => {
      return { ...state, apptDateId: payload };
    },
    updateApptDate: (state, { payload }) => {
      return { ...state, apptDate: payload };
    },
    updateApptDateTime: (state, { payload }) => {
      return { ...state, apptDateTime: payload };
    },
    updateApptTimeRange: (state, { payload }) => {
      const { id: apptTimeRangeId, startTime: apptTimeRangeStartTime, endTime: apptTimeRangeEndTime } = payload;
      return { ...state,  apptTimeRangeId, apptTimeRangeStartTime, apptTimeRangeEndTime };
    },
    clearApptTimeRange: (state) => {
      return { ...state,  apptTimeRangeId: null, apptTimeRangeStartTime: null, apptTimeRangeEndTime: null };
    },
    updateApptTimeslotId: (state, { payload }) => {
      return { ...state, apptTimeslotId: payload };
    },
    updateApptTimeslots: (state, { payload }) => {
      return { ...state, apptTimeslots: payload };
    },
    updateModeOfContact: (state, { payload }) => {
      return { ...state, modeOfContact: payload };
    },
    updateMobileUseUCD: (state, { payload }) => {
      return { ...state, mobileUseUCD: payload };
    },
    updateMobileNumber: (state, { payload }) => {
      return { ...state, mobileNumber: payload };
    },
    updateEmailUseUCD: (state, { payload }) => {
      return { ...state, emailUseUCD: payload };
    },
    updateEmail: (state, { payload }) => {
      return { ...state, email: payload };
    },
    updateOtpToken: (state, { payload }) => {
      return { ...state, otpToken: payload };
    },
    updateOtpTokenExpAt: (state, { payload }) => {
      return { ...state, otpTokenExpAt: payload };
    },
    updateOtp: (state, { payload }) => {
      return { ...state, otp: payload };
    },
    updateMobileNumberFromUCD: (state, { payload }) => {
      return { ...state, mobileNumberFromUCD: payload };
    },
    updateEmailFromUCD: (state, { payload }) => {
      return { ...state, emailFromUCD: payload };
    },
    clearMobileInfo: (state) => {
      return { ...state, mobileNumber: null, mobileNumberFromUCD: null, mobileUseUCD: null };
    },
    clearEmailInfo: (state) => {
      return { ...state, email: null, emailFromUCD: null, emailUseUCD: null };
    },
    updateState: (state, {payload}) => {
      return { ...state, ...payload };
    },
    updateHasAppt: (state, {payload}) => {
      return { ...state, ...payload };
    },
    updateIsCrps: (state, {payload}) => {
      return { ...state, isCrps: payload };
    },
    updateIsExperience: (state, {payload}) => {
      return { ...state, isExperience: payload };
    },
    updateBookingTxnId: (state, {payload}) => {
      return { ...state, bookingTxnId: payload };
    },
    updateCrpsError: (state, {payload}) => {
      return { ...state, crpsError: payload };
    },

    /* idTypeChooseNext: (state, { payload }) => {
      return { ...state, haveCpfAccountNumber: payload };
    },
    verifyNext: (state, { payload }) => {
      const { email, passport, otpToken } = payload;
      return { ...state, email, passport, otpToken };
    },
    appointmentNext: (state, {payload}) => {
      const { name, timeslotId, apptDateTime } = payload;
      return {...state, name, timeslotId, apptDateTime }
    },
    
    clearVerification: (state) => {
      // clear all except ack & haveCpfAccountNumber
      const {haveCpfAccountNumber} = state;
      return { ...state, ...initialStateVerification, haveCpfAccountNumber };
    },
    clearIdTypeChoose: (state) => {
      // clear all except ack
      return { ...state, ...initialStateVerification };
    },
    clearAppointment: (state) => {
      return {...state, timeslotId: null, apptDateTime: null }
    } */
  }
});

// export const { ack, idTypeChooseNext, verifyNext, clear, clearIdTypeChoose, clearVerification, appointmentNext, clearAppointment } = appointmentSlice.actions;
export const { clear, updateAck, updateMid, updateSid, 
  nextIdentity, 
  updateLanguage, updateHaveCompanion, updateCompanionIdType,
  updateCompanionNricFin, updateCompanionPassport,
  clearCompanion, updateApptDateId, updateApptTimeRange, clearApptTimeRange,
  updateApptTimeslotId, clearApptDateTime, updateLocationId,
  updateApptType, updateModeOfContact, updateMobileUseUCD,
  updateMobileNumber, updateEmailUseUCD, updateEmail, updateOtpToken, updateOtpTokenExpAt,
  updateOtp, updateMobileNumberFromUCD, updateEmailFromUCD,
  clearMobileInfo, clearEmailInfo, updateMidDesc, updateSidDesc,
  updateApptDateTime, updateLocationDesc, updateState, updateHasAppt,
  updateIsCrps, updateError, updateApptDate, updateApptTimeslots, clearLocation,
  clearIdentity, updateBookingTxnId,clearContactDetail,updateCompanionApptTimeslotId,
  updateNricFin, updatePassport, updateIsExperience,updateCrpsError, updateIdType
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
